import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import ThemeSelectField from 'component/priceBanner/selects/ThemeSelectField'
import ProductMultipleSelect from 'component/priceBanner/selects/ProductMultipleSelect'
import ListSelectField from 'component/priceBanner/selects/ListSelectField'
import CloseIconSVG from 'component/svgComponents/close'
import ApiRequest from 'utils/ApiRequest'
import API from 'constants/api'

const ALL_OPTION = {
  label: 'Todos',
  value: "todos"
}
const ALL_OPTION_ARRAY = {
  label: 'Todos',
  value: ["todos"]
}

const SideFilterProduct = ({
  sideFilterVisible,
  submit,
  translate,
  closeFilters,
  user,
  currentFilters = {},
  listsData = []
}) => {
  const initialState = {
    idBranches: [],
    theme: ALL_OPTION,
    list: ALL_OPTION_ARRAY,
    products: []
  }

  const [formData, setFormData] = useState(initialState)
  const [allBranches, setAllBranches] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [previousFormData, setPreviousFormData] = useState(initialState)
  const [allLists, setAllLists] = useState(listsData || [])

  useEffect(() => {
    if (listsData && listsData.length > 0) {
      setAllLists(listsData)
    }
  }, [listsData])

  useEffect(() => {
    const loadLists = async () => {
      const token = user?.dsToken
      if (!token) return
      
      if (!allLists || allLists.length === 0) {
        try {
          const api = new ApiRequest(token)
          const response = await api.get(API.FETCH_PRICEBANNER_LISTS)
          if (response && response.data && Array.isArray(response.data)) {
            setAllLists(response.data)
          }
        } catch (error) {
          // Error handled silently
        }
      }
    }
    
    loadLists()
  }, [user?.dsToken])

  const convertFiltersToFormData = (filters) => {
    const converted = { ...initialState }
    
    if (filters.productLms && Array.isArray(filters.productLms) && filters.productLms.length > 0) {
      converted.products = filters.productLms.map(lm => ({ 
        value: lm, 
        label: typeof lm === 'string' ? lm : lm.toString() 
      }))
    }
    
    if (filters.themeCode && filters.themeCode !== "todos") {
      const foundList = allLists.find(list => list.themeCode === filters.themeCode)
      const themeName = filters.themeName
        || (foundList ? foundList.themeName : null)
        || filters.themeCode
      converted.theme = { 
        value: filters.themeCode, 
        label: themeName
      }
    }
    
    if (filters.listId && filters.listId !== "todos") {
      const foundList = allLists.find(list => 
        list.idPriceBannerList === filters.listId || 
        list.id === filters.listId ||
        list.cdPricebannerThemesList === filters.listId ||
        String(list.idPriceBannerList) === String(filters.listId) ||
        String(list.id) === String(filters.listId) ||
        String(list.cdPricebannerThemesList) === String(filters.listId)
      )
      
      if (foundList) {
        const listName = foundList.name || foundList.nameList || foundList.listName
        converted.list = { 
          value: filters.listId, 
          label: listName
        }
      } else {
        converted.list = formData.list || { 
          value: filters.listId, 
          label: filters.listId
        }
      }
    } else if (filters.listIds && Array.isArray(filters.listIds) && filters.listIds.length > 0) {
      const foundLists = allLists.filter(list => 
        filters.listIds.includes(list.idPriceBannerList) || 
        filters.listIds.includes(list.id) ||
        filters.listIds.includes(list.cdPricebannerThemesList)
      )
      
      if (foundLists.length > 0) {
        const listName = foundLists[0].name || foundLists[0].nameList || foundLists[0].listName
        converted.list = { 
          value: filters.listIds, 
          label: listName
        }
      } else {
        converted.list = formData.list || { 
          value: filters.listIds, 
          label: filters.listIds.map(id => typeof id === 'string' ? id : id.toString()).join(', ') 
        }
      }
    }
    
    if (filters.idBranches && Array.isArray(filters.idBranches) && filters.idBranches.length > 0) {
      if (allBranches.length > 0) {
        const selectedBranches = allBranches.filter(branch => 
          filters.idBranches.includes(branch.value) || 
          (branch.idBranches && branch.idBranches.some(id => filters.idBranches.includes(id)))
        )
        converted.idBranches = selectedBranches
        converted.idBranchesCodes = filters.idBranches
      } else {
        converted.idBranchesCodes = filters.idBranches
      }
    }
    
    return converted
  }

  useEffect(() => {
    if (sideFilterVisible && Object.keys(currentFilters).length > 0 && allLists.length > 0) {
      const syncedData = convertFiltersToFormData(currentFilters)
      
      setFormData(prevData => {
        const hasChanges = JSON.stringify(prevData) !== JSON.stringify(syncedData)
        if (hasChanges) {
          setPreviousFormData(syncedData)
          return syncedData
        }
        return prevData
      })
    }
  }, [sideFilterVisible, currentFilters, allLists])

  useEffect(() => {
    if (allBranches.length > 0 && currentFilters.idBranches && currentFilters.idBranches.length > 0) {
      const selectedBranches = allBranches.filter(branch => 
        currentFilters.idBranches.includes(branch.value) || 
        (branch.idBranches && branch.idBranches.some(id => currentFilters.idBranches.includes(id)))
      )
      
      setFormData(prev => ({
        ...prev,
        idBranches: selectedBranches,
        idBranchesCodes: currentFilters.idBranches
      }))
    }
  }, [allBranches, currentFilters.idBranches])

  useEffect(() => {
    if (allLists.length > 0 && currentFilters.listId && currentFilters.listId !== "todos") {
      const foundList = allLists.find(list => 
        String(list.idPriceBannerList) === String(currentFilters.listId) ||
        String(list.id) === String(currentFilters.listId) ||
        String(list.cdPricebannerThemesList) === String(currentFilters.listId)
      )
      
      if (foundList) {
        const listName = foundList.name || foundList.nameList || foundList.listName
        setFormData(prev => ({
          ...prev,
          list: {
            value: currentFilters.listId,
            label: listName
          }
        }))
      }
    }
  }, [allLists, currentFilters.listId])

  useEffect(() => {
    if (
      !sideFilterVisible ||
      !currentFilters.themeCode ||
      currentFilters.themeCode === 'todos'
    ) {
      return
    }

    const foundList = allLists.find(list => list.themeCode === currentFilters.themeCode)
    const themeName = currentFilters.themeName
      || (foundList ? foundList.themeName : null)
      || currentFilters.themeCode

    setFormData(prev => {
      if (
        prev.theme?.value === currentFilters.themeCode &&
        prev.theme?.label === themeName
      ) {
        return prev
      }

      return {
        ...prev,
        theme: {
          value: currentFilters.themeCode,
          label: themeName,
        },
      }
    })
  }, [
    sideFilterVisible,
    currentFilters.themeCode,
    currentFilters.themeName,
    allLists,
  ])

  useEffect(() => {
    if (sideFilterVisible && 
        formData.idBranches.length === 0 && 
        allBranches.length > 0 && 
        (!currentFilters.idBranches || currentFilters.idBranches.length === 0)) {
      const allVisibleOptions = allBranches.filter((o) => o.visible !== false)
      handleFormChange('idBranches', allVisibleOptions)
    }
  }, [sideFilterVisible, allBranches, currentFilters.idBranches])

  const hasAnyFilterApplied = () => {
    const hasProducts = formData.products && formData.products.length > 0;
    const hasList = formData.list && formData.list.value;
    const hasTheme = formData.theme && formData.theme.value;
    const hasBranches = formData.idBranches && formData.idBranches.length > 0;
    return hasProducts || hasList || hasTheme || hasBranches;
  };

  const resetFilter = () => {
    const resetData = {
      ...initialState,
      theme: ALL_OPTION,
      list: ALL_OPTION_ARRAY
    }
    
    setFormData(resetData)
    setPreviousFormData(resetData)
    
    setTimeout(() => {
      if (allBranches.length > 0) {
        const allVisibleOptions = allBranches.filter((o) => o.visible !== false)
        handleFormChange('idBranches', allVisibleOptions)
      }
      setFormData(prev => ({
        ...prev,
        products: []
      }))
    }, 0)
  }

  const submitValues = () => {
    const transformedData = {
      idBranches: formData.idBranchesCodes || []
    }

    if (formData.theme) {
      if (formData.theme.value === "todos") {
        transformedData.themeCode = "todos"
      } else {
        transformedData.themeCode = formData.theme.value
        if (formData.theme.label) {
          transformedData.themeName = formData.theme.label
        }
      }
    }

    if (formData.list) {
      if (formData.list.value === "todos") {
        transformedData.listId = "todos"
      } else if (Array.isArray(formData.list.value)) {
        transformedData.listIds = formData.list.value
      } else {
        transformedData.listId = formData.list.value
      }
    }

    if (formData.products && formData.products.length > 0) {
      transformedData.productLms = formData.products.map(product => product.value)
    } else {
      transformedData.productLms = []
    }

    setPreviousFormData(formData)
    submit(transformedData)
    closeFilters()
  }

  const handleFormChange = (field, selectedValue) => {
    if (field === 'idBranches') {
      const branchCodes = selectedValue.flatMap((item) => {
        if (item.idBranches) return item.idBranches
        if (item.isBranch) return item.value
        return []
      })

      setFormData((prev) => ({
        ...prev,
        [field]: selectedValue,
        [`${field}Codes`]: branchCodes
      }))
    } else if (field === 'theme') {
      setFormData((prev) => ({
        ...prev,
        theme: selectedValue || null
      }))
    } else if (field === 'list') {
      setFormData((prev) => ({
        ...prev,
        list: selectedValue || null
      }))
    } else if (field === 'products') {
      setFormData((prev) => ({
        ...prev,
        products: selectedValue || []
      }))
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: selectedValue
      }))
    }
  }

  return (
    <>
      <div style={{ display: sideFilterVisible ? 'shown' : 'none' }} className='bg-filter' />
      <div style={{ display: sideFilterVisible ? '' : 'none' }} className='right-filter-container-side-list'>
        <CloseIconSVG className="right-filter-svg" onClick={() => closeFilters()} />
        <h3 className='margin-bottom-triple'>
          <strong>{translate('mobile.filter')}</strong>
        </h3>
        <div>
          <ProductMultipleSelect
            label={translate('price.banner.products.lm')}
            placeholder={translate('price.banner.select.lm')}
            value={formData.products}
            onChange={(value) => handleFormChange('products', value)}
            required={true}
            fill={true}
            showHelperArea={false}
          />
        </div>
        <div>
          <ListSelectField
            label={translate('price.banner.listname')}
            placeholder={translate('price.banner.select.list')}
            user={user}
            translate={translate}
            onChange={(e) => handleFormChange('list', e)}
            value={formData.list}
            required={true}
            fill={true}
            showAllOption={true}
            groupByName={true}
          />
        </div>
        <div>
          <ThemeSelectField
            label={translate('price.banner.theme')}
            placeholder={translate('option.all')}
            user={user}
            translate={translate}
            onChange={(e) => handleFormChange('theme', e)}
            value={formData.theme}
            required={true}
            fill={true}
            showAllOption={true}
          />
        </div>
        <div>
          <RegionBranchMultipleSelect
            required
            name='idBranches'
            label={translate('irc.store')}
            placeholder={translate('field.selectMultiStores')}
            user={user}
            translate={translate}
            onChange={(e) => handleFormChange('idBranches', e.target.value)}
            value={formData.idBranches}
            getAllBranchs={setAllBranches}
          />
        </div>

        <div style={{ marginTop: '30px' }} className='flex flex-row gap-filters'>
          <button
            className={`btn btn-danger-outline full-w`}
            onClick={resetFilter}>
            {translate('suggestions.cleanFilters')}
          </button>
          <button
            className={`btn btn-primary full-w`}
            disabled={!hasAnyFilterApplied()}
            onClick={submitValues}
          >
            {translate('commonReport.filter')}
          </button>
        </div>
      </div>
    </>
  )
}

SideFilterProduct.propTypes = {
  sideFilterVisible: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
  closeFilters: PropTypes.func.isRequired,
  user: PropTypes.object,
  currentFilters: PropTypes.object,
  listsData: PropTypes.array
}

export default SideFilterProduct
export { SideFilterProduct }
